export const achievementData = {
    bio : "Putting quantified achievements on a resume is great, but I just don’t work with hard numbers. I have no data to support the quality of my work. If you have lots of relevant experience, the heading statement of your resume will be a summary.",
    achievements : [
        {   
            id : 1,
            title : 'OCI Generative AI Certified Professional',
            details : 'Building a strong understanding of LLMs, RAG, LangChain, Semantic search, Vector databases and skills at using OCI Generative AI Service. ',
            date : 'July, 2024',
            field : 'GEN AI',
            image : 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQAITwEbHlhD4WbyP--TKKdCanREboMSmdvog&ss'
        },
        {
            id : 2,
            title : 'Python for Data Science',
            details : 'Able to write Python scripts and perform basic hands-on data analysis using IBMs Jupyter-based lab environment.',
            date : 'Jan, 2024',
            field : 'Data Science',
            image : 'https://blog.logomaster.ai/hs-fs/hubfs/ibm-logo-4.jpeg?width=1008&height=681&name=ibm-logo-4.jpeg'
        },
        {
            id : 3,
            title : 'DSA in C++',
            details : 'C++ certification provided by Sololearn for completing basic to advanced topics of DSA.',
            date : 'Aug, 2023',
            field : 'DSA',
            image : 'https://logowik.com/content/uploads/images/sololearn8062.jpg'
        },
        {
            id : 4,
            title : 'Postman API Certification',
            details : 'Master basics of APIs and interacting with them using Postman.',
            date : 'Nov, 2022',
            field : 'API',
            image : 'https://logowik.com/content/uploads/images/postman-api-platform6643.logowik.com.webp'
        }

    ]
}


// Do not remove any fields.
// Leave it blank instead as shown below.

/*

export const achievementData = {
    bio : "",
    achievements : []
}

*/